import { render } from "./orderTable.vue?vue&type=template&id=2068be65&scoped=true"
import script from "./orderTable.vue?vue&type=script&lang=js"
export * from "./orderTable.vue?vue&type=script&lang=js"

import "./orderTable.vue?vue&type=style&index=0&id=2068be65&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2068be65"]])

export default __exports__